import React from 'react'
import { toast } from 'react-toastify'
import NotificationToast from 'components/Toast/notificationToast'

export default class ToastMiddleware {
  constructor(rootStore) {
    this.rootStore = rootStore
    this.notificationAudio = undefined

    // Compatibilidade com o uso antigo (this.notify era o toast do react-toastify): várias telas
    // ainda usam notify.TYPE, notify.POSITION e notify.update; sem isso quebravam com
    // "Cannot read properties of undefined (reading 'WARNING')".
    this.notify.TYPE = toast.TYPE
    this.notify.POSITION = toast.POSITION
    this.notify.dismiss = toast.dismiss
    this.notify.update = (toastId, options = {}) => {
      if (toastId === null || toastId === undefined) return
      const title = options.title || (typeof options.render === 'string' ? options.render : '')
      const description = options.description || options.desc || ''
      toast.update(toastId, {
        render: ({ closeToast }) => (
          <NotificationToast
            type={this.normalizeType(options.type)}
            title={title}
            description={description}
            onDismiss={closeToast}
            durationMs={options.autoClose || 4000}
          />
        ),
      })
    }
  }

  normalizeType = (type) => {
    const normalizedType = String(type || 'info').toLowerCase()
    if (normalizedType === 'error' || normalizedType === 'warning' || normalizedType === 'info')
      return normalizedType

    return 'info'
  }

  playNotificationSound = (soundEnabled) => {
    if (!soundEnabled || typeof window === 'undefined') return

    if (!this.notificationAudio) this.notificationAudio = new Audio('/sounds/notificationsound.wav')

    this.notificationAudio.currentTime = 0
    this.notificationAudio.play().catch(() => {})
  }

  notify = (payloadOrTitle, options = {}) => {
    const payload =
      typeof payloadOrTitle === 'object' && payloadOrTitle !== null
        ? payloadOrTitle
        : { title: payloadOrTitle, ...options }

    const type = this.normalizeType(payload.type)
    const title = payload.title || ''
    const description = payload.description || payload.desc || ''
    const actionLabel = payload.actionLabel
    const onAction = payload.onAction
    const durationMs = payload.autoClose || 4000
    const soundEnabled = Boolean(payload.sound)

    this.playNotificationSound(soundEnabled)

    return toast(
      ({ closeToast }) => (
        <NotificationToast
          type={type}
          title={title}
          description={description}
          actionLabel={actionLabel}
          onAction={onAction}
          onDismiss={closeToast}
          durationMs={durationMs}
        />
      ),
      {
        position: payload.position || 'top-left',
        autoClose: durationMs,
        closeButton: false,
        hideProgressBar: true,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: false,
        icon: false,
        className: 'ps-notification-toast-shell',
        bodyClassName: 'ps-notification-toast-body',
        progressClassName: 'ps-notification-toast-progress',
        style: {
          background: 'transparent',
          boxShadow: 'none',
          padding: 0,
          margin: 0,
          minHeight: 'unset',
          overflow: 'visible',
        },
      }
    )
  }
}
